import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobSeekerDetails } from "../../redux/employerJob/employerJobSlice";

function EmployerJobSeekerDetails() {
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const { employerJobList, loading, error } = useSelector((state) => state.EmployerListedJob);
  const { currentUser } = useSelector((state) => state.user); // Still used for userType check

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId  && jobId) {
      dispatch(fetchJobSeekerDetails({ employerId: userId, jobId }));
    }
  }, [dispatch, currentUser, jobId]);

  if (loading) return <div className="p-4">Loading...</div>;
  if (error) return <div className="p-4 text-red-500">Error: {error.message}</div>;

  const job = employerJobList.find((j) => j._id === jobId);
  const jobSeekerDetails = job?.jobSeekerDetails;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Job Seeker Details for {jobId}</h2>
      {jobSeekerDetails ? (
        <div className="space-y-4">
          <p><strong>Name:</strong> {jobSeekerDetails.firstName} {jobSeekerDetails.lastName}</p>
          <p><strong>Email:</strong> {jobSeekerDetails.email}</p>
          <p><strong>Phone:</strong> {jobSeekerDetails.phoneNumber}</p>
          <p><strong>Address:</strong> {jobSeekerDetails.address}, {jobSeekerDetails.localGovernment}, {jobSeekerDetails.state}</p>
          <p><strong>Job Mode:</strong> {jobSeekerDetails.jobMode}</p>
          <p><strong>Availability:</strong> {jobSeekerDetails.availability?.[jobId] || "Not specified"}</p>
        </div>
      ) : (
        <p>No details available for this job.</p>
      )}
    </div>
  );
}

export default EmployerJobSeekerDetails;